import {clearString, FullAlphabet} from "./helpers/stringHelpers";

const Spider = {
    mineaplhabet: function (missing) {
        let myAlphabet = FullAlphabet.filter((str) => {
            return str !== missing[0].toLowerCase().replace('ch', '*') &&
                str !== missing[1].toLowerCase().replace('ch', '*') &&
                str !== missing[2].toLowerCase().replace('ch', '*')
        })
        return myAlphabet;
    }


}
const SEPARATOR = ''
export const methods = {
    cypher: function (input, hasCh=false, missing = [], params, sep = SEPARATOR) {
        let cyphered = []
        let cleared = clearString(input,hasCh).replaceAll(/[ ]/g,'')
        missing.forEach((char)=>{
            cleared = cleared.replaceAll(char,'')
        })
        let characters = cleared.split('');//.forEach((char)=>{ });
        for (let i = 0; i < characters.length; i=i+2){
            cyphered.push(characters[i]);
        }
        if(characters.length%2==0){
            for (let i = (characters.length-1); i > 0 ; i=i-2){
                cyphered.push(characters[i]);
            }
        }else{
            for (let i = (characters.length); i > 0 ; i=i-2){
                cyphered.push(characters[i]);
            }
        }
        return cyphered.join(sep)
            .replaceAll('*','ch')
    },
    decypher: function (input, hasCh=false, missing = [], params) {
        let deciphered = []
        let text = hasCh ? input.replace('ch','*') : input;
        let characters = text.split('')//.forEach((char) => {//.replace(' ','')
        //});
        // let upto = characters.length%2==0 ? characters.length/2 : (characters.length+1)/2;
        // for(let i =0;i < upto;i++){
        //     deciphered.push(characters[i]);
        //     deciphered.push(characters[(characters.length-1)-i]);
        // }
        if(characters.length%2==0){
            for(let i =0;i < characters.length/2;i++){
                deciphered.push(characters[i]);
                deciphered.push(characters[(characters.length-1)-i]);
            }
        }else{
            for(let i =0;i <= Math.floor((characters.length)/2);i++){
                deciphered.push(characters[i]);
                i!=(characters.length-1)-i && deciphered.push(characters[(characters.length-1)-i]);
            }
        }

        return deciphered.join('');
    },
};

export default {...methods,SEPARATOR}